import { render, staticRenderFns } from "./BidPrivateComponent.vue?vue&type=template&id=045c29f0"
import script from "./BidPrivateComponent.vue?vue&type=script&lang=js"
export * from "./BidPrivateComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports